import styled from 'styled-components';

import { sp } from '@main/theme';

/** The form item wrapper for labeled inputs */
export const FormItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${sp(1)};
`;

/** Label wrapper */
export const LabelWrapper = styled.label`
  color: black;
  margin-bottom: ${sp(0.3)};
  font-weight: bold;
  font-size: ${sp(2)};
  margin-left: ${sp(0.1)};
`;
